import produce from 'immer';

export const Types = {
  SIGN_IN_REQUEST: '@user/SIGN_IN_REQUEST',
  SIGN_IN_SUCCESS: '@user/SIGN_IN_SUCCESS',
  SIGN_IN_ERROR: '@user/SIGN_IN_ERROR',
  SIGN_OUT: '@user/SIGN_OUT',
  SIGN_OUT_LEGADO_REQUEST: '@user/SIGN_OUT_LEGADO_REQUEST',
  REFRESH_INVALID_TOKEN_REQUEST: '@user/REFRESH_INVALID_TOKEN_REQUEST',
  REFRESH_INVALID_TOKEN_SUCCESS: '@user/REFRESH_INVALID_TOKEN_SUCCESS',
  REFRESH_INVALID_TOKEN_ERROR: '@user/REFRESH_INVALID_TOKEN_ERROR',
  GET_CHANGE_TOKEN_REQUEST: '@user/GET_CHANGE_TOKEN_REQUEST',
  GET_CHANGE_TOKEN_SUCCESS: '@user/GET_CHANGE_TOKEN_SUCCESS',
  GET_CHANGE_TOKEN_ERROR: '@user/GET_CHANGE_TOKEN_ERROR',
  GET_RECUPERAR_SENHA_REQUEST: '@user/GET_RECUPERAR_SENHA_REQUEST',
  GET_RECUPERAR_SENHA_SUCCESS: '@user/GET_RECUPERAR_SENHA_SUCCESS',
  GET_RECUPERAR_SENHA_ERROR: '@user/GET_RECUPERAR_SENHA_ERROR',
  POST_LOGIN_REQUEST: '@user/POST_LOGIN_REQUEST',
  POST_LOGIN_SUCCESS: '@user/POST_LOGIN_SUCCESS',
  POST_LOGIN_ERROR: '@user/POST_LOGIN_ERROR',
  POST_RECAPTCHA_VERIFY_REQUEST: '@user/POST_RECAPTCHA_VERIFY_REQUEST',
  POST_RECAPTCHA_VERIFY_SUCCESS: '@user/POST_RECAPTCHA_VERIFY_SUCCESS',
  POST_RECAPTCHA_VERIFY_ERROR: '@user/POST_RECAPTCHA_VERIFY_ERROR',
  POST_RECUPERAR_SENHA_REQUEST: '@user/POST_RECUPERAR_SENHA_REQUEST',
  POST_RECUPERAR_SENHA_SUCCESS: '@user/POST_RECUPERAR_SENHA_SUCCESS',
  POST_RECUPERAR_SENHA_ERROR: '@user/POST_RECUPERAR_SENHA_ERROR',
};

const INITIAL_STATE = {
  loading: false,
  success: false,
  response: [],
  unsuccessResponse: [],
  error: null,
  loggedIn: false,
  usuario: {},
  accessToken: null,
  accessTokenExpiration: null,
  refreshToken: null,
  refreshTokenExpiration: null,
  userType: null,
  token: null,
  getChangeToken: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  postLogin: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  postRecaptchaVerify: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getRecuperarSenha: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  postRecuperarSenha: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.SIGN_IN_REQUEST: {
        draft.loading = true;
        break;
      }
      case Types.SIGN_IN_SUCCESS: {
        draft.loading = false;
        draft.token = action.payload.token;
        draft.accessToken = action.payload.token.access_token;
        draft.accessTokenExpiration = action.payload.token.expiration;
        draft.refreshToken = action.payload.token.refresh_token;
        draft.loggedIn = true;
        draft.usuario = action.payload.usuario;
        break;
      }
      case Types.SIGN_IN_ERROR: {
        draft.error = action.payload.error;
        break;
      }
      case Types.REFRESH_INVALID_TOKEN_REQUEST: {
        draft.loading = true;
        break;
      }
      case Types.REFRESH_INVALID_TOKEN_SUCCESS: {
        draft.loading = true;
        draft.token = action.payload.token;
        draft.accessToken = action.payload.token.access_token;
        draft.accessTokenExpiration = action.payload.token.expiration;
        draft.refreshToken = action.payload.token.refresh_token;
        draft.loggedIn = true;
        draft.usuario = action.payload.usuario;
        break;
      }
      case Types.REFRESH_INVALID_TOKEN_ERROR: {
        draft.loading = false;
        // draft.loggedIn = false;
        draft.error = action.payload.error;
        break;
      }
      case Types.SIGN_OUT: {
        draft.loggedIn = false;
        draft.token = null;
        draft.usuario = {};
        draft.accessToken = null;
        draft.accessTokenExpiration = null;
        draft.refreshToken = null;
        draft.refreshTokenExpiration = null;
        draft.error = null;
        break;
      }
      case Types.SIGN_OUT_LEGADO_REQUEST: {
        break;
      }
      case Types.GET_CHANGE_TOKEN_REQUEST: {
        draft.getChangeToken.loading = true;
        break;
      }
      case Types.GET_CHANGE_TOKEN_SUCCESS: {
        draft.getChangeToken.loading = false;
        draft.getChangeToken.response = action.payload.response;
        draft.getChangeToken.success = action.payload.success;
        draft.usuario = action.payload.usuario;
        break;
      }
      case Types.GET_CHANGE_TOKEN_ERROR: {
        draft.getChangeToken.loading = false;
        draft.getChangeToken.error = action.payload.error;
        break;
      }
      case Types.POST_LOGIN_REQUEST: {
        draft.postLogin.loading = true;
        draft.postLogin.success = false;
        draft.postLogin.error = null;
        draft.postLogin.isError = null;
        draft.postLogin.unsuccessResponse = null;
        break;
      }
      case Types.POST_LOGIN_SUCCESS: {
        draft.usuario = action.payload.usuario;
        draft.token = action.payload.token;
        draft.accessToken = action.payload.token.access_token;
        draft.accessTokenExpiration = action.payload.token.expiration;
        draft.refreshToken = action.payload.token.refresh_token;
        if (action.payload.changePassword == 'false') draft.loggedIn = true;
        else draft.loggedIn = false;
        draft.postLogin.loading = false;
        draft.postLogin.success = action.payload.isSuccess;
        draft.postLogin.isError = false;
        break;
      }
      case Types.POST_LOGIN_ERROR: {
        draft.postLogin.loading = false;
        draft.postLogin.isError = true;
        draft.postLogin.error = action.payload.error;
        draft.postLogin.unsuccessResponse = action.payload.unsuccessResponse;
        break;
      }
      case Types.POST_RECAPTCHA_VERIFY_REQUEST: {
        draft.postRecaptchaVerify.loading = true;
        break;
      }
      case Types.POST_RECAPTCHA_VERIFY_SUCCESS: {
        draft.postRecaptchaVerify.loading = false;
        draft.postRecaptchaVerify.response = action.payload.response;
        draft.postRecaptchaVerify.success = action.payload.success;
        break;
      }
      case Types.POST_RECAPTCHA_VERIFY_ERROR: {
        draft.postRecaptchaVerify.loading = false;
        draft.postRecaptchaVerify.error = action.payload.error;
        draft.postRecaptchaVerify.isError = true;
        break;
      }
      case Types.POST_RECUPERAR_SENHA_REQUEST: {
        draft.postRecuperarSenha.loading = true;
        break;
      }
      case Types.POST_RECUPERAR_SENHA_SUCCESS: {
        draft.postRecuperarSenha.loading = false;
        draft.postRecuperarSenha.response = action.payload.response;
        draft.postRecuperarSenha.success = action.payload.success;
        break;
      }
      case Types.POST_RECUPERAR_SENHA_ERROR: {
        draft.postRecuperarSenha.loading = false;
        draft.postRecuperarSenha.error = action.payload.error;
        draft.postRecuperarSenha.isError = true;
        break;
      }
      case Types.GET_RECUPERAR_SENHA_REQUEST: {
        draft.getRecuperarSenha.loading = true;
        break;
      }
      case Types.GET_RECUPERAR_SENHA_SUCCESS: {
        draft.getRecuperarSenha.loading = false;
        draft.getRecuperarSenha.response = action.payload.response;
        draft.getRecuperarSenha.success = action.payload.success;
        break;
      }
      case Types.GET_RECUPERAR_SENHA_ERROR: {
        draft.getRecuperarSenha.loading = false;
        draft.getRecuperarSenha.error = action.payload.error;
        draft.getRecuperarSenha.isError = true;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  signInRequest: (auth) => ({
    type: Types.SIGN_IN_REQUEST,
    payload: { auth },
  }),
  signInSuccess: (token, usuario) => ({
    type: Types.SIGN_IN_SUCCESS,
    payload: { token, usuario },
  }),
  signInError: (error) => ({
    type: Types.SIGN_IN_ERROR,
    payload: { error },
  }),
  signOut: () => ({
    type: Types.SIGN_OUT,
  }),
  signOutLegadoRequest: () => ({
    type: Types.SIGN_OUT_LEGADO_REQUEST,
  }),
  refreshInvalidTokenRequest: (invalidToken) => ({
    type: Types.REFRESH_INVALID_TOKEN_REQUEST,
    payload: { invalidToken },
  }),
  refreshInvalidTokenSuccess: (token, usuario) => ({
    type: Types.REFRESH_INVALID_TOKEN_SUCCESS,
    payload: { token, usuario },
  }),
  refreshInvalidTokenError: (error) => ({
    type: Types.REFRESH_INVALID_TOKEN_ERROR,
    payload: { error },
  }),
  getChangeTokenRequest: (queryParams) => ({
    type: Types.GET_CHANGE_TOKEN_REQUEST,
    payload: { queryParams },
  }),
  getChangeTokenSuccess: (token, usuario) => ({
    type: Types.GET_CHANGE_TOKEN_SUCCESS,
    payload: { token, usuario },
  }),
  getChangeTokenError: (error) => ({
    type: Types.GET_CHANGE_TOKEN_ERROR,
    payload: { error },
  }),
  postLoginRequest: (usuarioParams) => ({
    type: Types.POST_LOGIN_REQUEST,
    payload: { usuarioParams },
  }),
  postLoginSuccess: (token, usuario, isSuccess, changePassword) => ({
    type: Types.POST_LOGIN_SUCCESS,
    payload: { token, usuario, isSuccess, changePassword },
  }),
  postLoginError: (unsuccessResponse, error) => ({
    type: Types.POST_LOGIN_ERROR,
    payload: { unsuccessResponse, error },
  }),
  postRecaptchaVerifyRequest: (queryParams) => ({
    type: Types.POST_RECAPTCHA_VERIFY_REQUEST,
    payload: { queryParams },
  }),
  postRecaptchaVerifySuccess: (response, success) => ({
    type: Types.POST_RECAPTCHA_VERIFY_SUCCESS,
    payload: { response, success },
  }),
  postRecaptchaVerifyError: (error) => ({
    type: Types.POST_RECAPTCHA_VERIFY_ERROR,
    payload: { error },
  }),
  postRecuperarSenhaRequest: (params) => ({
    type: Types.POST_RECUPERAR_SENHA_REQUEST,
    payload: { params },
  }),
  postRecuperarSenhaSuccess: (response, success) => ({
    type: Types.POST_RECUPERAR_SENHA_SUCCESS,
    payload: { response, success },
  }),
  postRecuperarSenhaError: (error) => ({
    type: Types.POST_RECUPERAR_SENHA_ERROR,
    payload: { error },
  }),
  getRecuperarSenhaRequest: (params) => ({
    type: Types.GET_RECUPERAR_SENHA_REQUEST,
    payload: { params },
  }),
  getRecuperarSenhaSuccess: (response, success) => ({
    type: Types.GET_RECUPERAR_SENHA_SUCCESS,
    payload: { response, success },
  }),
  getRecuperarSenhaError: (error) => ({
    type: Types.GET_RECUPERAR_SENHA_ERROR,
    payload: { error },
  }),
};
